import { SET_PRODUCTS, SET_PRODUCTS_DETAIL} from "../ConstAction";

const initialState = {};
export const ProductsData = (state = initialState, action) => {

  switch (action.type) {
    case SET_PRODUCTS:
      return {
        ...state,
        products: action.response,
      };
    case SET_PRODUCTS_DETAIL :
      return {
        ...state,
        productDetail: action.response
      }
    default:
      return { ...state };
  }
};
